var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrowZ(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg_sidebar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3227",
    "data-name": "Group 3227",
    transform: "translate(-752 -2276)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1882",
    "data-name": "Rectangle 1882",
    width: 24,
    height: 24,
    transform: "translate(752 2276)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_ads__marketing__announcement__megaphone__loud_6424946",
    transform: "translate(755 2279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M50.148,21.414a3.432,3.432,0,0,0-2.3-3.237v6.471A3.428,3.428,0,0,0,50.148,21.414Z",
    transform: "translate(-32.148 -13.887)",
    fill: "#e8eafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M11.352,24.447c.124.008.259.019.4.031V17.5c-.137.012-.271.024-.4.031a.474.474,0,0,0-.1.022H9.434A3.433,3.433,0,0,0,8.4,24.262l.9,5.491a1.33,1.33,0,1,0,2.624-.43l-.807-4.9h.125A.285.285,0,0,0,11.352,24.447Z",
    transform: "translate(-6 -13.432)",
    fill: "#e8eafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M31.1,21.659a.369.369,0,0,0,.3.15.313.313,0,0,0,.112-.019.375.375,0,0,0,.258-.356V7.111a.376.376,0,0,0-.672-.225c-1.76,2.385-5.282,3.45-7.719,3.8v7.176C25.816,18.209,29.341,19.274,31.1,21.659Zm-6.759-9.012a.376.376,0,0,1-.053-.747A16.15,16.15,0,0,0,30.3,9.83a.376.376,0,1,1,.392.641,15.384,15.384,0,0,1-3.107,1.418,18.265,18.265,0,0,1-3.188.752.281.281,0,0,1-.054.006Z",
    transform: "translate(-16.848 -6.742)",
    fill: "#e8eafd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowZ);
export default __webpack_public_path__ + "static/media/growZ.ca28c1a6b28c22d59f465fc8b9c654d3.svg";
export { ForwardRef as ReactComponent };